
<a
  class="text-blueGray-500 block"
  href="#pablo"
  (click)="toggleDropdown($event)"
  #btnDropdownRef
>
  <div class="items-center flex">
    <span
      class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
    >
      <img
        alt="..."
        class="w-full rounded-full align-middle border-none shadow-lg"
        src="../../../../assets/img/default-profile.png"
      />
    </span>
  </div>
</a>
<div class="min-w-48 w-56 z-50" #popoverDropdownRef2>
  <div
    class="rtl bg-white z-50 float-left p-4 list-none text-right rounded shadow-lg mt-2 w-56 min-w-48"
    [ngClass]="dropdownPopoverShow2 ? 'block' : 'hidden'"
  >
    <div
      class="text-sm font-bold py-2 flex w-full whitespace-nowrap bg-transparent text-gray-500 "
    >
    <div class="flex justify-between">
      <div class="flex items-center">
        <span> موجودی فعلی: </span>
        <span class="text-gray-900 px-1"> ۰ تومان </span>
      </div>
      <button class="test-sm rounded-full text-primary py-1 px-2 border-primary ms-4" routerLink="/user/wallet"> افزایش موجودی </button>
    </div>
    
  </div>
    <div class="h-0 my-2 border border-solid border-blueGray-100"></div>
    <a
      href="#pablo"
      class="text-sm py-2 font-bold flex w-full whitespace-nowrap bg-transparent text-gray-500 hover:bg-primary-light"
    >
    <img class="px-2 w-10" src="../../../assets/img/icon/vpn_key.svg" alt="">
    فراموشی رمز عبور 
    </a>
    <button (click)="logout()"
    class="text-sm py-2 font-bold flex w-full whitespace-nowrap bg-transparent text-gray-500 hover:bg-primary-light"
  >
  <img class="px-2 w-10" src="../../../assets/img/icon/Logout_outline.svg" alt="">
  خروج از حساب کاربری 
    </button>
  </div>
</div>
